import React from 'react';

const LoadingSpinner = ({ children, loading }) => {
	return loading ? (
		<div className='flex justify-center items-center h-[700px]'>
			<div class='flex justify-center items-center'>
				<div class='animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mr-4 ' />
				<p>Fetching Data...</p>
			</div>
		</div>
	) : (
		<div className='min-h-96'>{children}</div>
	);
};

export default LoadingSpinner;
